const protocol = "https";
const baseUrl = "symbol-search.tradingview.com";
const proxy = "api.allorigins.win/raw";
export const config = {
    protocol,
    baseUrl,
    endpoint: protocol + "://" + baseUrl,
    proxyEndpoint: protocol + "://" + proxy,
};
//# sourceMappingURL=config.js.map